import React from "react";
import classNames from "classnames";
import { SectionSplitProps } from "../../utils/SectionProps";
import SectionHeader from "./partials/SectionHeader";


const propTypes = {
  ...SectionSplitProps.types,
};

const defaultProps = {
  ...SectionSplitProps.defaults,
};

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {
  const outerClasses = classNames(
    "features-split section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "features-split-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const splitClasses = classNames(
    "split-wrap",
    invertMobile && "invert-mobile",
    invertDesktop && "invert-desktop",
    alignTop && "align-top"
  );

  const sectionHeader = {
    title: "Projects",
    paragraph: "Some of my projects available in my Github profile .",
  };

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>
            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-left"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary text-ubuntu-light tt-u mb-8">
                  Mobile
                </div>
                <h4 className="mt-0 text-ubuntu-bold mb-12">cTracker App</h4>
                <p className="m-0">
                  App built with React Native to show the situation of covid-19
                  in Brazil ,prevention tips and how to get in touch with
                  government agencies (call, site or whatsapp).
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <div className="row-iphone">
                  <img
                    className="cover-img"
                    style={{ paddingLeft: 150 }}
                    src={require("./../../assets/images/Home.png")}
                    alt="My"
                  />
                  <img
                    className="cover-img"
                    style={{ paddingRight: 150 }}
                    src={require("./../../assets/images/Info.png")}
                    alt="My"
                  />
                </div>
              </div>
            </div>

            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-right"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary text-ubuntu-light tt-u mb-8">
                  Mobile
                </div>
                <h4 className="mt-0 text-ubuntu-bold mb-12">Ecoleta</h4>
                <p className="m-0">
                  Ecoleta - is a way to connect companies and entities that
                  collect organic and inorganic waste, to people who need to
                  dispose of their waste in an ecological way. Project built
                  during NLW - Next Level Week offered by [Rocketseat].
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <div className="gif-img">
                  <img
                    src={require("./../../assets/images/mock_mobile.gif")}
                    alt="My"
                  />
                </div>
              </div>
            </div>

            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-left"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-secondary text-ubuntu-light tt-u mb-8">
                  Frontend and <span className='text-color-primary'>Mobile</span>
                </div>
                <h4 className="mt-0 text-ubuntu-bold mb-12">Alukey</h4>
                <p className="m-0">
                  Alukey, is an easy software for real estate rentals. The project has a workflow where realtors and brokers can register their properties and have access to lead information, schedules, etc. Site for real estate promotion and a mobile app available in my github profile (react-native-properties)
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <div className="gif-img">
                  <img
                    src={require("./../../assets/images/alukeyimg.png")}
                    alt="My"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <h4 className="text-ubuntu-light">For more visit my <a href="http://github.com/adlerke" className='text-ubuntu-bold text-nice'> Github </a> page</h4>
      </div>
    </section>
  );
};

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;
